import * as Styled from './HelpContent.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const HelpContent = ({
  helpContent
}) => /*#__PURE__*/_jsx(Styled.HelpContentContainer, {
  children: helpContent
});